@if (fileUrl) {
  <div class="relative h-full">
    <pdf-viewer
      [src]="sanitizedFileUrl"
      [rotation]="0"
      [original-size]="false"
      [show-all]="true"
      [fit-to-page]="true"
      [zoom]="zoomLevel"
      [zoom-scale]="'page-width'"
      [stick-to-page]="false"
      [render-text]="true"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [show-borders]="false"
      style="width: 100%; height: 100%;"
    ></pdf-viewer>

    <div class="absolute right-4 top-4 z-20 flex flex-col items-end gap-2">      <button
        type="button"
        class="grid h-9 w-9 place-items-center rounded-xl border border-lGray600 bg-gradient-to-tr from-lBlack to-lBlue700 text-lWhite transition-transform duration-200"
        (click)="toggleMenu()"
        aria-label="Alternar menu do PDF"
      >
        <l-icon
          class="material-symbols-outlined !text-xl leading-none transition-transform duration-200"
          [class.rotate-45]="!isMenuOpen"
        >
          close
        </l-icon>
      </button>

      @if (isMenuOpen) {
        <div
          class="w-44 origin-top-right rounded-xl border border-lGray600 bg-gradient-to-tr from-lBlack to-lBlue700 p-1.5 text-lWhite shadow-panel backdrop-blur-sm transition-all duration-200"
        >
          @for (item of menuItems; track item.title) {
            <button
              type="button"
              class="flex w-full items-center gap-2 rounded-lg px-3 py-2.5 text-left text-sm hover:bg-lWhite/10"
            >
              <l-icon class="material-symbols-outlined text-sm leading-none">
                {{ item.icon }}
              </l-icon>
              <span>{{ item.title }}</span>
            </button>
          }
        </div>
      }
      
    </div>

    <div class="absolute bottom-6 right-4 z-20 rounded-xl border border-lGray600 bg-gradient-to-tr from-lBlack to-lBlue700 p-2 shadow-panel backdrop-blur-sm"> 
      <div class="flex flex-col items-center gap-2"> 
        <button type="button" class="grid h-8 w-8 place-items-center rounded-xl text-lWhite hover:bg-lWhite/8" (click)="zoomIn()" aria-label="Aumentar zoom" > 
          <l-icon class="material-symbols-outlined text-[26px] leading-none">zoom_in</l-icon> 
        </button> 
        <span class="h-px w-8 bg-lGray600"></span> 
        <button type="button" class="grid h-8 w-8 place-items-center rounded-xl text-lWhite hover:bg-lWhite/10" (click)="zoomOut()" aria-label="Diminuir zoom" > 
          <l-icon class="material-symbols-outlined text-[26px] leading-none">zoom_out</l-icon> 
        </button> 
      </div>
    </div>
  </div>
} @else {
  <div class="grid h-full min-h-96 place-items-center px-6 text-center text-lWhite/75">
    <p>Arquivo PDF indisponível para esta aula.</p>
  </div>
}
